import React, { Component } from 'react'
import {Section, Title, SectionButton} from "../../utils"
import styled from "styled-components"
import {Link} from "gatsby"
import {styles} from "../../utils"

export default class ContactInfo extends Component {
    render() {
        return (
            <ContactInfoWrapper>
                <Section>
                    <Title message="Adresse" title="Adresse 3 Rue Saint-Nicolas, Bordeaux, Nouvelle-Aquitaine 33800"/>
                    <Title message="Téléphone" title="0669403943"/>
                </Section>
            </ContactInfoWrapper>
        )
    }
}

const ContactInfoWrapper = styled.div`
  width: 100%;
  background: ${styles.colors.mainGray};

`
